import { EditorManager } from '../prosemirror/editor-manager';
import { Subscriber } from 'rxjs';
import { MenuEvent } from '../prosemirror/event/menu-event';

export class MenuManager {

    constructor(
        private editorManager: EditorManager,
        private suggestionRequestEventSubscriber: Subscriber<boolean>,
        private customCommandSubscriber: Subscriber<MenuEvent>) {
    }

    onNew($event: Event) {
        this.editorManager.clear();
    }
    onUndo($event) {
        this.editorManager.undo();
    }
    onRedo($event) {
        this.editorManager.redo();
    }

    onShowSuggestions($event) {
        this.suggestionRequestEventSubscriber.next(true);
    }

    onCustomCommand(commandId: string) {
        /* get selection */
        const commandEvent: MenuEvent = new MenuEvent();
        commandEvent.commandId = commandId;
        commandEvent.currentTextSelected = this.editorManager.getSelectedText();
        this.customCommandSubscriber.next(commandEvent);
    }

}
